var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.45455 18.5455L5.45455 17.0909C5.45455 10.0895 9.36218 6.90909 14.1818 6.90909L15.5651 6.90909C15.4109 9.09964 14.7287 10.4255 12.9484 12.0007C12.0727 12.7753 12.1469 13.2225 12.5782 12.9658C13.8939 12.183 14.9161 11.2783 15.6525 10.1818C16.1649 9.41871 16.5389 8.56272 16.7769 7.59027C16.9119 7.0385 17.0032 6.44924 17.0511 5.81818C17.0604 5.69594 17.0676 5.57366 17.0732 5.45134C17.0915 5.05078 17.4143 4.72727 17.8152 4.72727C18.2185 4.72727 18.5475 5.05438 18.5295 5.45727C18.4978 6.16575 18.4191 6.82501 18.2938 7.44145C18.4611 8.38255 18.5455 9.65964 18.5455 11.2727C18.5455 15.2895 15.2895 18.5455 11.2727 18.5455C9.81818 18.5455 8.36364 17.8182 5.45455 18.5455Z",
    fill: "#9E4C35"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFall);
export default __webpack_public_path__ + "static/media/fall.74bd284292a2ad5ede11ad6e398a9425.svg";
export { ForwardRef as ReactComponent };